module.exports = __webpack_public_path__ + "img/icon-location-input.84726380.svg";